import React from 'react';
import { isObject } from 'underscore';
interface RunSqlQueriesTableProps {
  data:any[]; 
}

const RunSqlQueriesTable: React.FC<RunSqlQueriesTableProps> = ({ data }) => {
  var tableHead: string[][] = [];
  var tableBody: string[][] = [];

  data.forEach((item) => {
    tableHead.push(Object.keys(item));
  })

  data.forEach((item) => {
    tableBody.push(Object.values(item));
  })
  //for handle the boolean values FP-10649
  const renderCell = (cell: any) => {
    if (typeof cell === "boolean") {
      return cell ? "True" : "False"; 
    }
    return isObject(cell) ? "" : cell; 
  };
  return (
    <div>
      <div style={{ overflow: 'scroll', width: '100%', maxHeight: '400px' }}>
        <table className='admin-table text-center'>
          <tr className='admin-row-header'>
            {tableHead[0].map((value) => (
              <td style={{ width: '170px' }}>{value}</td>
            ))}
          </tr>
          <tbody>
          {tableBody.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex}>{renderCell(cell)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  );
}

export default RunSqlQueriesTable;
